import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const AccommodationPackageTileGrid = styled.div`
  height: 100%;
  padding: ${rem(20)};
  display: grid;
  column-gap: ${rem(32)};
  grid-template:
    "header"
    "content"
    "." minmax(${rem(12)}, 1fr)
    "pricing" auto / 1fr;

  ${mediaQueryUp.tablet} {
    grid-template:
      "header header"
      "content pricing" auto / minmax(0, 1fr) min-content;
  }
`

function AccommodationPackageTile(props: PropsWithChildren) {
  return <AccommodationPackageTileGrid {...props} />
}

export default AccommodationPackageTile
